import { NgModule } from '@angular/core';
import {SearchWelcomeComponent} from "./search-welcome/search-welcome.component";
import { SearchDefaultComponent } from './search-default/search-default.component';
import {SharedModule} from "../../../../../shared/shared.module";

/**
 * These are components that may be used in an Angular search result template.
 */
@NgModule({
  imports: [
    SharedModule
  ],
  declarations: [
    SearchWelcomeComponent,
    SearchDefaultComponent
  ],
  providers: [],
  exports: [
    SearchWelcomeComponent,
    SearchDefaultComponent
  ]
})
export class SearchResultModule {}
